import type { FC } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import type { ButtonProps } from '../Button';
import { Button } from '../Button';
import { CloseIcon } from '../Icon/_glyph/Close';
import { cnCloseButton } from './CloseButton.cn';

export type CloseButtonProps = IClassNameProps &
    Pick<
        ButtonProps,
        'size' | 'title' | 'disabled' | 'onClick' | 'inline' | 'disableFocusOnClick' | 'aria-label'
    >;

export const CloseButton: FC<CloseButtonProps> = ({ className, ...restProps }) => {
    return (
        <Button
            view="clear"
            className={cnCloseButton(null, [className])}
            icon={<CloseIcon />}
            {...restProps}
        />
    );
};
